export function getLocalDateValue(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function getTodayDateValue() {
  return getLocalDateValue();
}

export function getMinEventDateValue() {
  const minEventDate = new Date();
  minEventDate.setDate(minEventDate.getDate() + 15);

  return getLocalDateValue(minEventDate);
}

export function isDateBeforeMinEventDate(dateValue) {
  return Boolean(dateValue) && dateValue < getMinEventDateValue();
}
